<template>
    <div class="quickPay">
        <!-- <img class="quickPay-header-image" src="@/assets/images/pay/pay-quick.png" alt="" /> -->
        <!-- hruting 修改于20221123轮播banner -->
        <!-- 必传，广告投放区域。1、首页banner  2、地图 3、快捷缴费的banner 4、支付界面 5.泊位停车-->
        <Swipe :areaType="5" :singleImg="singleImg" :className="`quickPay-header-image`"></Swipe>
        <div class="quickPay-content">
            <BerthKeyBoard text="请输入泊位号" ref="BerthKeyBoard" :carNoList.sync="carNoList" @confirmBtnFn="getResult"
                :showDefault="false" />

            <van-button class="comfirm-btn" v-debounce="next">下一步</van-button>
        </div>

        <telephonne />
    </div>
</template>

<script>
    import BerthKeyBoard from "@/components/berth-keyboard.vue";

    import {
        secondToMinute
    } from "@/libs/tools";
    import {
        queryParkInfoByStallCode
    } from "@/api/api";
    import Telephonne from "@/components/telephone";
    import Swipe from "@/components/base/swipe.vue";

    export default {
        name: "BerthParking",
        components: {
            BerthKeyBoard,
            Telephonne,
            Swipe
        },

        data() {
            return {
                active: 0,
                carNoList: [], //单个车牌号数组
                stallCode: "",
                singleImg:require('@/assets/images/pay/pay-quick.png')
            };
        },

        mounted() {},
        methods: {
            secondToMinute,

            getResult(stallCode, flag) {
                this.stallCode = stallCode;
                if (flag) this.next();
            },
            next() {
                if (this.stallCode.length !== 6) {
                    this.$toast("请输入正确泊位号");
                    return;
                }
                queryParkInfoByStallCode({
                    stallCode: this.stallCode
                }).then((res) => {
                    if (res.code == 200) {
                        let str =
                            `${process.env.VUE_APP_BASE_API}qginsideparking/page/advPayDetail?stallCode=${this.stallCode}`;
                        wx.miniProgram.navigateTo({
                            url: `/pages/tab2/webview/webview?jumpUrl=${encodeURIComponent(str)}`,
                        });
                    }
                });
            },
        },
    };
</script>

<style lang="less" scoped>
    .quickPay {
        /deep/ .quickPay-header-image {
            width: 750px;
            height: 200px;
        }

        .quickPay-wrap {
            background: #fff;
            padding: 15px 0;

            .quickPay-type {
                width: 702px;
                height: 64px;
                border: 1px solid #dbdada;
                border-radius: 16px;
                margin: 0 auto;

                .quickPay-type-item {
                    height: 100%;
                    flex: 1;

                    .quickPay-type-item-text {
                        font-size: 28px;
                        color: #666666;
                        text-align: center;
                        line-height: 64px;
                        position: relative;

                        &::before {
                            content: "";
                            width: 1px;
                            height: 40px;
                            position: absolute;
                            background-color: #dbdada;
                            top: 12px;
                            left: 0;
                        }
                    }

                    &:nth-child(1) {
                        .quickPay-type-item-text {
                            position: relative;

                            &::before {
                                content: "";
                                width: 0;
                            }
                        }
                    }

                    .quickPay-type-item-textA {
                        font-size: 28px;
                        height: 100%;
                        line-height: 64px;
                        color: #fff;
                        text-align: center;
                        background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
                        border-radius: 15px;
                    }

                    img {
                        width: 12px;
                        height: 8px;
                        margin-left: 10px;
                    }
                }
            }
        }

        .quickPay-content {
            padding: 24px;
            background-color: #fff;

            .quickPay-code-list {
                width: 702px;
                min-height: 204px;
                background: #009af31a;
                border-radius: 16px;
                padding: 24px;

                .quickPay-code-history {
                    font-size: 30px;
                    color: #212121;
                    margin-bottom: 23px;
                }

                .quickPay-code-wrap {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-around;

                    // overflow-x: scroll;
                    &:after {
                        content: "";
                        width: 302px; //这个宽度和子元素宽度一致
                        height: 0;
                        display: block;
                    }

                    .quickPay-code-item-green {
                        width: 302px;
                        font-size: 46px;
                        margin: 10px 0;
                        flex-shrink: 0;
                        background: url("~@/assets/images/pay/car-bg-green.png") no-repeat;
                        color: #110b0d;
                    }

                    .quickPay-code-item-blue {
                        width: 302px;
                        font-size: 46px;
                        margin: 10px 0;

                        flex-shrink: 0;
                        background: url("~@/assets/images/pay/car-bg-blue.png") no-repeat;
                        color: #fff;
                    }

                    .quickPay-code-item-yellow {
                        width: 302px;
                        font-size: 46px;
                        margin: 10px 0;

                        flex-shrink: 0;
                        background: url("~@/assets/images/pay/car-bg-yellow.png") no-repeat;
                        color: #110b0d;
                    }

                    .quickPay-code-item-temp {
                        width: 302px;
                        font-size: 46px;
                        margin: 10px 0;

                        flex-shrink: 0;
                        background: url("~@/assets/images/pay/car-bg-temp.png") no-repeat;
                        color: #110b0d;
                    }

                    .quickPay-code-item-black {
                        width: 302px;
                        font-size: 46px;
                        margin: 10px 0;

                        flex-shrink: 0;
                        background: url("~@/assets/images/pay/car-bg-black.png") no-repeat;
                        color: #fff;
                    }

                    .quickPay-code-item-white {
                        width: 302px;
                        font-size: 46px;
                        margin: 10px 0;

                        flex-shrink: 0;
                        background: url("~@/assets/images/pay/car-bg-white.png") no-repeat;
                        color: #110b0d;
                    }

                    .quickPay-code-item-yellow-green {
                        width: 302px;
                        font-size: 46px;
                        margin: 10px 0;

                        flex-shrink: 0;
                        background: url("~@/assets/images/pay/car-bg-yellow-green.png") no-repeat;
                        color: #110b0d;
                    }

                    .quickPay-code-item {
                        height: 88px;
                        position: relative;
                        flex-shrink: 0;
                        background-size: 100% 100%;
                        margin-right: 16px;

                        .code-item-number {
                            white-space: nowrap;

                            line-height: 88px;
                            text-align: center;
                        }

                        .quickPay-code-itemA {
                            position: absolute;
                            width: 100%;
                            height: 100%;
                            left: 0;
                            top: 0;
                            background: #009af3cc;
                            border-radius: 8px;

                            img {
                                position: absolute;
                                width: 48px;
                                height: 48px;
                                left: 0;
                                right: 0;
                                top: 0;
                                bottom: 0;
                                margin: auto;
                            }
                        }
                    }
                }
            }

            .quickPay-tip {
                margin-top: 70px;

                img {
                    width: 24px;
                    height: 24px;
                }

                p {
                    font-size: 26px;
                    color: #616161;
                    margin-left: 8px;
                }
            }
        }

        .content-other {
            .content-other-itemA {
                width: 702px;
                height: 64px;
                background: #009af333;
                border-radius: 16px;
                margin: 0 22px;

                p {
                    color: #009af3;
                    line-height: 64px;
                    text-align: center;
                }
            }

            .content-other-item {
                width: 702px;
                height: 64px;
                // background: #009AF333;
                border-radius: 16px;
                margin: 0 22px;

                p {
                    color: #666666;
                    line-height: 64px;
                    text-align: center;
                }
            }

            .content-other-btn {
                width: 750px;
                padding: 22px;

                .content-btn {
                    width: 343px;
                    height: 70px;
                    border-radius: 16px;
                }
            }
        }
    }

    .car-delete {
        height: 30px;
        width: 30px;
        position: absolute;
        top: -10px;
        right: -10px;
        color: #000;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;

        background-color: red;

        .line {
            height: 5px;
            width: 20px;
            background-color: #fff;
            border-radius: 10px;
        }

        // background: url("~@/assets/images/pay/close.png") no-repeat;
        // background-size: 100% 100%;
    }

    .record-list {
        padding: 16px 24px;

        .record-list-item {
            width: 702px;
            border-radius: 16px;
            background-color: #fff;
            margin-bottom: 16px;

            .record-item-header {
                width: 100%;
                height: 73px;
                padding: 0 30px;
                border-bottom: 1px solid #dbdada;

                .record-item-site {
                    font-size: 30px;
                    color: #333333;
                }

                .record-item-status {
                    font-size: 30px;
                }

                .color-gray {
                    color: #999;
                }

                .color-red {
                    color: #f96161;
                }
            }

            .parkingPay-carInfo-content {
                flex: 1;
                padding: 24px 44px 27px;

                .carInfo-content-header {
                    font-size: 32px;
                    font-weight: 500;
                    color: #212121;
                    margin-bottom: 30px;
                }

                .carInfo-content-item {
                    margin-bottom: 16px;

                    .carInfo-content-item1 {
                        width: 24px;
                        height: 24px;
                    }

                    .carInfo-content-item2 {
                        width: 24px;
                        height: 28px;
                    }

                    .carInfo-content-item-title {
                        margin-left: 17px;
                        vertical-align: top;
                    }

                    .carInfo-content-item-value {
                        margin-left: auto;
                        color: #666666;
                    }

                    .money {
                        font-size: 30px;
                        color: #009af3;
                    }
                }
            }

            .record-item-pay {
                padding: 0 30px 30px;
                display: flex;
                flex-direction: row-reverse;
                justify-content: space-between;

                .record-item-pay-btn {
                    width: 310px;
                    height: 60px;
                    white-space: nowrap;
                    color: #fff;
                    border-radius: 10px;
                    background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
                }
            }
        }
    }

    .comfirm-btn {
        color: #fff;
        background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
    }
</style>